import { Component, Input, OnInit } from '@angular/core';
import { MngUserDataModel } from 'src/app/management/models/managementModel';
import { ManagementService } from 'src/app/management/services/management.service';

@Component({
  selector: 'app-mng-menu-list',
  templateUrl: './mng-menu-list.component.html',
  styleUrls: ['./mng-menu-list.component.scss']
})
export class MngMenuListComponent implements OnInit {

  @Input() mngUser: MngUserDataModel;

  @Input() userLastLoginDate: string;

  constructor(private managementService: ManagementService) { }

  ngOnInit(): void {
  }

   logout() {
    this.managementService.logout();
  }

}
